import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import ControlsContainer from "./ControlsContainer";
import styled from "styled-components";
import AccountOverView from "./AccountOverview";
import AllGoalsContainer from "./AllGoalsContainer";
import News from "./News";

import FAQ from "./FAQ";
import ThankYouModal from "./ThankYouPopUp";
import ManageScreen from "./ManageScreen/ManageScreen";
import WelcomeMessage from "../WelcomeMessage/WelcomeMessage";
import AccountDetailsModal from "../AccountDetailsModal/AccountDetailsModal";
import {
  getStepsByGoal,
  setGoal,
  deleteGoal,
  getNewDashboardInformation,
  resetAdvisorName,
  setGoalToLaunchPayload,
} from "../../redux/actions";
import ContactAdvisorPopup from "./ContactAdvisorPopup";
import { analytics } from "../../analytics";
import { SET_LOADING } from "../../redux/action-types";

const Wrapper = styled.div`
  .section {
    margin-top: 30px;

    .goalNewsContainer {
      display: flex;
      gap: 30px;
      @media (max-width: 480px) {
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .goalsContainer {
        width: 60%;
        @media (max-width: 480px) {
          width: 100%;
        }
      }

      .newsFaqContainer {
        width: 40%;
        @media (max-width: 480px) {
          width: 100%;
        }
      }
    }
  }

  .welcomeMessage-container {
    right: 0;
    top: 70px;
    position: absolute;
  }
`;

const NewDashboardContent = ({ newDashboardData, transferGoals }) => {
  let { from } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { deleteUserGoalDetails, advisorName } = useSelector(
    (state) => state.user
  );
  const [activeTab, setActiveTab] = useState("goalsContainer");
  const [isAdvisorPopupVisible, setIsAdvisorPopupVisible] = useState(false);
  const [isThankYouModalVisible, setIsThankYouModalVisible] = useState(false);
  const [width, setWidth] = useState(1000);
  const [isAccountDetailsModalVisible, setIsAccountDetailsModalVisible] =
    useState(false);
  const [goalIdToManage, setGoalIdToManage] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    handleResize();
  }, [setWidth]);

  useEffect(() => {
    if (from) {
      if (from === "fromManage") setActiveTab("manage");
      else setIsThankYouModalVisible(true);
    }
  }, [from]);

  useEffect(() => {
    if (deleteUserGoalDetails) {
      dispatch(getNewDashboardInformation());
    }
  }, [deleteUserGoalDetails, dispatch]);

  useEffect(() => {}, [deleteUserGoalDetails]);

  useEffect(() => {
    if (newDashboardData) {
    }
  }, [newDashboardData]);

  useEffect(() => {
    if (advisorName) {
      setIsAdvisorPopupVisible(true);
    }
  }, [advisorName]);

  const handleManageButtonClick = () => {
    setActiveTab("manage");
  };

  const handleMissionControlClick = () => {
    setActiveTab("goalsContainer");
  };

  const handleNewGoalClick = () => {
    history.push("/goal-picker");
  };

  const handleThankYouModalClose = () => {
    setIsThankYouModalVisible(false);
    history.push("/strategy-screen");
  };

  const handleManageAccountClickFromGoalCard = (goalId) => {
    setActiveTab("manage");
    setGoalIdToManage(goalId);
  };

  const handleDeleteGoal = (goalId, goalType) => {
    dispatch({ type: SET_LOADING, payload: true });
    dispatch(deleteGoal(goalId));
    analytics.track("Goal Removed", {
      goalId: goalId || "",
      goalType: goalType || "",
    });
  };

  const handleApplicationStatusOnClick = (goalId) => {
    let goalName, goalStatus, ibAccountType;
    if (goalId) {
      let selectedGoalName =
        newDashboardData.length > 0 &&
        newDashboardData.filter((data) => data.goalId === goalId);
      if (selectedGoalName?.length > 0) {
        goalName = selectedGoalName[0].goalType;
        goalStatus = selectedGoalName[0].goalStatus;
        ibAccountType = selectedGoalName[0].ibAccountType;
      }
    }
    let type, path;
    if (goalName === "Education") {
      type = "Education";
      path = "/education";
    } else if (goalName === "Retirement") {
      type = "Retirement";
      path = "/retirement";
    } else if (goalName === "Major Purchase") {
      type = "Major Purchase";
      path = "/major_purchase";
    } else if (goalName === "Build Wealth") {
      type = "Build Wealth";
      path = "/build_wealth";
    }
    if (goalStatus === "Launched" && ibAccountType == null) {
      const payload = {
        goalId: goalId,
      };
      dispatch(setGoalToLaunchPayload(payload));
      history.push("/select-custodian-type");
    } else if (goalStatus === "Launched" && ibAccountType !== null) {
      const payload = {
        goalId: goalId,
      };
      dispatch(setGoalToLaunchPayload(payload));
      if (ibAccountType === "INDIVIDUAL") history.push("/individual-form");
      else if (ibAccountType === "JOINT") history.push("/joint-form");
      else history.push("/ria-form");
    } else if (goalStatus !== "NotLinked") {
      dispatch(
        getStepsByGoal({
          type,
          link: goalId,
        })
      ).then(() => {
        history.push(path);
      });
    } else {
      dispatch(
        setGoal({
          id: goalId,
        })
      ).then(() => {
        history.push("/dashboard");
      });
    }
  };

  const handleContactAdvisorClick = () => {
    window.open("https://tactivewealth.com/connect-with-a-wealth-advisor/");
  };

  const handleThankYouPopupClose = () => {
    dispatch(resetAdvisorName());
    setIsAdvisorPopupVisible(false);
  };

  return (
    <>
      {isAccountDetailsModalVisible && (
        <AccountDetailsModal onClose={setIsAccountDetailsModalVisible} />
      )}
      {isAdvisorPopupVisible && (
        <ContactAdvisorPopup
          advisorEmail={advisorName?.advisorEmail}
          onClose={handleThankYouPopupClose}
        />
      )}
      <Wrapper>
        {isThankYouModalVisible && (
          <ThankYouModal onClose={handleThankYouModalClose} />
        )}
        {((history.location.pathname === "/strategy-screen" ||
          history.location.pathname ===
            "/strategy-screen/:fromGoalSubmission" ||
          history.location.pathname === "/strategy-screen/fromManage") &&
          width > 480) || (
          <div className="welcomeMessage-container">
            <WelcomeMessage
              actionOnClick={() => {
                setIsAccountDetailsModalVisible(true);
              }}
            />
          </div>
        )}
        <ControlsContainer
          manageButtonClick={handleManageButtonClick}
          missionControlClick={handleMissionControlClick}
          newGoalClick={handleNewGoalClick}
          currentActiveTab={activeTab}
          newDashboardData={newDashboardData}
        />
        {activeTab === "goalsContainer" && (
          <div className="section">
            <AccountOverView />
          </div>
        )}

        <div className="section">
          {activeTab === "goalsContainer" && (
            <div className="goalNewsContainer">
              <div className="goalsContainer">
                <AllGoalsContainer
                  newDashboardData={newDashboardData}
                  manageAccountClick={handleManageAccountClickFromGoalCard}
                  handleAddGoal={handleNewGoalClick}
                  applicationStatusOnClick={handleApplicationStatusOnClick}
                  deleteGoal={handleDeleteGoal}
                  handleContactAdvisorClick={handleContactAdvisorClick}
                />
              </div>
              <div className="newsFaqContainer">
                <News />
                <FAQ />
              </div>
            </div>
          )}
          {activeTab === "manage" && (
            <div className="manageTransferContainer">
              <ManageScreen
                transferGoals={transferGoals}
                setActiveTab={setActiveTab}
                goalIdToManage={goalIdToManage}
              />
            </div>
          )}
        </div>
      </Wrapper>
    </>
  );
};

export default NewDashboardContent;
